export * from './withAuthorization';


// WEBPACK FOOTER //
// ./src/components/hocs/index.tsx